// extracted by mini-css-extract-plugin
module.exports = {"BottomSubscribe":"BottomSubscribe_BottomSubscribe__oay_f"};